import { useEffect } from 'react';
import { useNavigate, useRoutes } from 'react-router-dom';

import { AUTH_EVENT } from './lib/auth';
import { routes } from './routes';

export function App(): JSX.Element | null {
  const navigate = useNavigate();
  const element = useRoutes(routes);

  useEffect(() => {
    function onLogout(): void {
      navigate('/login', { replace: true });
    }
    window.addEventListener(AUTH_EVENT.LOGOUT, onLogout);
    return () => window.removeEventListener(AUTH_EVENT.LOGOUT, onLogout);
  }, [navigate]);

  return element;
}
